import { motion } from "framer-motion";

import {
  BookOpen,
  Users,
  Globe,
  Lightbulb,
  Award,
  Search,
  TrendingUp,
  Heart,
  Download,
  Video,
  FileText,
  HelpCircle,
  Mail,
  Phone,
  ArrowRight,
  ChevronRight,
  MapPin,
  PartyPopper,
  Shirt,
  QrCode,
  GraduationCap,
  Calendar,
  Layers,User
} from "lucide-react";
import DataFetcher from "../hooks/DataFetcher";
import CallForPapers from "../components/CallforPapers";
import PricingBlock from "../components/PricingBlock";
import Equipo from "../components/Equipo";
import Comite from "../components/Comite";
import juan from "../img/seminario/juan.jpg";
import luis from "../img/seminario/luis.jpg";

const url =
  "https://portales.utpl.edu.ec/beportales/jsonapi/node/congresos_seminarios/ab8826a0-2f37-4e7d-8ba3-b6d8f9c1e9f9" +
  "?include=field_imagen_portada.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5," +
  "field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15,field_bloque16,field_bloque17" +
  "&fields[media--image]=field_media_image";
const conferencias = [
  {
    id: 1,
    nombre: "Ph. D. Juan Ignacio Pulido",
    tema: "La nueva era del turismo cultural: inteligencia, innovación y transformación",
    bio: "Doctor en Economía por la Universidad de Jaén (con Premio Extraordinario) y máster en Unión Económica y Monetaria por la UNED. Ha completado su formación de posgrado como visiting researcher en varias universidades europeas (Siena, Bolonia, La Sorbona, Leeds Metropolitan).",
    foto: juan,
    scholar:"https://scholar.google.com/citations?user=o0tv1AEAAAAJ&hl=es",
    
  },

  {
    id: 2,
    nombre: "Ph. D. Luis César Herrero Pietro",
    tema:"El mapa mundial del capital cultural. Medición y análisis mediante un índice compuesto",
bio:"Doctor en Ciencias Económicas y Empresariales y Profesor Titular de Economía Aplicada en la Universidad de Valladolid (España). Ha sido becario del Instituto del Territorio y Urbanismo y realizado estancias de investigación en la Universidad Católica de Lovaina (Bélgica) y el Instituto Agronómico Mediterráneo de Montpellier (Francia).",
    foto: luis,
    scholar:"https://scholar.google.com/citations?user=AO-KpioAAAAJ&hl=es"
  },
];
function Congreso() {
  const DataDisplay = ({ data }) => (
    <div>
      {/*HERO */}
      <section
        id="inicio"
        className="relative pt-12 pb-20 lg:pt-20 lg:pb-28 bg-gradient-to-b from-[#004270]/5 via-white to-white overflow-hidden"
      >
        <div className="max-w-6xl m-auto p-10">
          <div className="absolute top-0 right-0 w-[45%] h-full bg-[#004270]/5 rounded-bl-[120px] pointer-events-none hidden md:block" />
          <div className="absolute top-1/3 left-1/4 w-80 h-80 bg-[#febe10]/10 rounded-full blur-[100px] pointer-events-none" />

          <div className="mt-10">
            <div
              className="[&_h2]:text-[#004270] [&_h2_strong]:text-[#febe10] [&_h2]:font-black [&_h2]:text-3xl [&_h2]:sm:text-5xl [&_h2]:lg:text-[54px]
            [&_p]:text-slate-600 [&_p]:leading-relaxed max-w-3xl"
              dangerouslySetInnerHTML={{
                __html: data.texto_portada,
              }}
            />
          </div>

          <div className=" mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4 pt-2">
            <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex items-start space-x-3">
              <Calendar className="w-5 h-5 text-[#004270] mt-1 flex-shrink-0" />

              <div
                className="[&_p]:text-[#004270] [&_p]:leading-relaxed  [&_p]:text-base"
                dangerouslySetInnerHTML={{
                  __html: data.bloque1,
                }}
              />
            </div>

            <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex items-start space-x-3">
              <MapPin className="w-5 h-5 text-[#004270] mt-1 flex-shrink-0" />

              <div
                className="[&_p]:text-[#004270] [&_p]:leading-relaxed  [&_p]:text-base"
                dangerouslySetInnerHTML={{
                  __html: data.bloque2,
                }}
              />
            </div>

            <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex items-start space-x-3">
              <Users className="w-5 h-5 text-[#004270] mt-1 flex-shrink-0" />

              <div
                className="[&_p]:text-[#004270] [&_p]:leading-relaxed  [&_p]:text-base"
                dangerouslySetInnerHTML={{
                  __html: data.bloque3,
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/*PRESENTACIÓN*/}
      <section
        id="presentacion"
        className="py-20 bg-slate-50 border-y border-slate-200 relative"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <div
              className="[&_h2]:text-2xl [&_h2]:sm:text-4xl  [&_h2]:font-bold [&_h2]:tracking-tight 
               mt-4 [&_p]:text-slate-600 [&_p]:text-sm [&_p]:sm:text-base [&_p]:eading-relaxed"
              dangerouslySetInnerHTML={{
                __html: data.bloque4,
              }}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Tarjeta de Presentación 1 */}
            <div className="p-8 rounded-2xl bg-white border border-slate-200 hover:border-[#004270]/30 hover:shadow-lg transition-all group">
              <div className="w-12 h-12 rounded-xl bg-[#004270]/10 text-[#004270] flex items-center justify-center mb-6 group-hover:bg-[#004270] group-hover:text-white transition-all">
                <Layers className="w-6 h-6" />
              </div>

              <div
                className="[&_h3]:text-lg  [&_h3]:font-bold [&_h3]:text-[#004270] [&_h3]:tracking-tight 
               mt-4 [&_p]:text-slate-600 [&_p]:text-sm [&_p]:sm:text-base [&_p]:eading-relaxed"
                dangerouslySetInnerHTML={{
                  __html: data.bloque5,
                }}
              />
            </div>

            {/* Tarjeta de Presentación 2 */}
            <div className="p-8 rounded-2xl bg-white border border-slate-200 hover:border-[#004270]/30 hover:shadow-lg transition-all group">
              <div className="w-12 h-12 rounded-xl bg-[#004270]/10 text-[#004270] flex items-center justify-center mb-6 group-hover:bg-[#004270] group-hover:text-white transition-all">
                <Users className="w-6 h-6" />
              </div>

              <div
                className="[&_h3]:text-lg  [&_h3]:font-bold [&_h3]:text-[#004270] [&_h3]:tracking-tight 
               mt-4 [&_p]:text-slate-600 [&_p]:text-sm [&_p]:sm:text-base [&_p]:eading-relaxed"
                dangerouslySetInnerHTML={{
                  __html: data.bloque6,
                }}
              />
            </div>

            {/* Tarjeta de Presentación 3 */}
            <div className="p-8 rounded-2xl bg-white border border-slate-200 hover:border-[#004270]/30 hover:shadow-lg transition-all group">
              <div className="w-12 h-12 rounded-xl bg-[#004270]/10 text-[#004270] flex items-center justify-center mb-6 group-hover:bg-[#004270] group-hover:text-white transition-all">
                <FileText className="w-6 h-6" />
              </div>

              <div
                className="[&_h3]:text-lg  [&_h3]:font-bold [&_h3]:text-[#004270] [&_h3]:tracking-tight 
               mt-4 [&_p]:text-slate-600 [&_p]:text-sm [&_p]:sm:text-base [&_p]:eading-relaxed"
                dangerouslySetInnerHTML={{
                  __html: data.bloque7,
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* LÍNEAS TEMÁTICAS */}
      <section id="lineas" className="py-20 bg-[#004270]">
        <div className="max-w-7xl mx-auto px-4">
          {/* Encabezado */}
          <div
            className="
        max-w-4xl mx-auto mb-16
        [&_h2]:text-center
        [&_h2]:text-5xl
        [&_h2]:font-black
        [&_h2]:text-white
        [&_h2]:mb-4
        [&_p]:text-center
        [&_p]:text-lg
        [&_p]:text-white
      "
            dangerouslySetInnerHTML={{
              __html: data.bloque8,
            }}
          />

          {/* Líneas temáticas */}
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {[
              data.bloque9,
              data.bloque10,
              data.bloque11,
              data.bloque12,
              data.bloque13,
              data.bloque14,
              data.bloque15,
              data.bloque17,
            ].map((bloque, index) => (
              <article
                key={index}
                className="
            group
            relative
            overflow-hidden
            rounded-3xl
            bg-white
            p-8
            shadow-[0_8px_30px_rgb(0,0,0,0.05)]
            transition-all
            duration-300
            hover:-translate-y-2
            hover:shadow-[0_20px_50px_rgb(0,0,0,0.12)]
          "
              >
                {/* Barra decorativa */}
                <div className="absolute left-0 top-0 h-2 w-full bg-[#febe10]" />

                {/* Número */}
                <div className="mb-6">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#004270]/10 text-[#004270] font-bold text-lg">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>

                <div
                  className="
              [&_h3]:text-2xl
              [&_h3]:font-bold
              [&_h3]:text-[#004270]
              [&_h3]:mb-4
              [&_h3]:leading-tight

              [&_p]:text-slate-600
              [&_p]:leading-7
              [&_p]:text-[15px]

              [&_strong]:text-[#004270]

              [&_ul]:mt-4
              [&_ul]:space-y-2

              [&_li]:text-slate-600
              [&_li]:leading-6
            "
                  dangerouslySetInnerHTML={{
                    __html: bloque,
                  }}
                />
              </article>
            ))}
          </div>
        </div>
      </section>

{/* Conferencistas */}
<section className="max-w-5xl mx-auto px-4 mt-10">
     <h2 className="text-center font-black m-10">Conferencias magistrales</h2>
<div className="grid gap-8 md:grid-cols-2">
  {conferencias.map((conferencia, index) => (
    <motion.article
      key={conferencia.id}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.15 }}
      viewport={{ once: true }}
      whileHover={{ y: -8 }}
      className="group overflow-hidden rounded-3xl border border-gray-200 bg-white shadow-lg transition-all duration-300 hover:shadow-2xl"
    >
      {/* Imagen */}
      <div className="relative h-[450px] overflow-hidden">
        <img
          src={conferencia.foto}
          alt={conferencia.nombre}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-[#004270]/90 via-[#004270]/30 to-transparent" />

        <div className="absolute bottom-0 left-0 w-full p-6">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/20 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-white backdrop-blur">
            <GraduationCap size={15} />
            Conferencista Magistral
          </span>

          <h3 className="mt-4 text-2xl font-bold leading-tight text-white">
            {conferencia.nombre}
          </h3>
        </div>
      </div>

      {/* Contenido */}
      <div className="p-7">
        {/* Tema */}
        <div className="flex items-start gap-3">
          <div className="rounded-xl bg-[#C89B3C]/10 p-3">
            <BookOpen className="text-[#C89B3C]" size={20} />
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-gray-400">
              Conferencia
            </p>

            <h4 className="mt-1 text-lg font-semibold leading-7 text-[#004270]">
              {conferencia.tema}
            </h4>
          </div>
        </div>

        {/* Bio */}
        <div className="mt-7 flex items-start gap-3">
          <div className="rounded-xl bg-[#004270]/10 p-3">
            <User className="text-[#004270]" size={20} />
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-gray-400">
              Semblanza
            </p>

            <p className="mt-2 text-gray-600 leading-7">
              {conferencia.bio}
            </p>
          </div>
        </div>

     {/* Google Scholar */}
{conferencia.scholar && (
  <div className="mt-8 pt-6 border-t border-gray-100">
    <a
      href={conferencia.scholar}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 rounded-xl bg-[#004270] px-4 py-2 text-sm font-semibold text-white transition hover:bg-[#00345A]"
    >
      <Globe size={18} />
      Ver perfil en Google Scholar
      <ArrowRight size={16} />
    </a>
  </div>
)}
      </div>
    </motion.article>
  ))}
</div>
</section>

      <section id="inscripcion">
        <PricingBlock></PricingBlock>
      </section>
      {/* call for papers */}
      <section id="papers">
        <CallForPapers></CallForPapers>
      </section>
   <Comite></Comite>
   <section id="equipo">
        <Equipo></Equipo>
      </section>

   


    </div>
  );

  return (
    <DataFetcher url={url}>{(data) => <DataDisplay data={data} />}</DataFetcher>
  );
}

export default Congreso;
